/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const PictureInPictureLeaveIcon = ({ width = 18, height = 18, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 18 18' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0.5C0 0.223858 0.223858 0 0.5 0H6.5C6.77614 0 7 0.223858 7 0.5C7 0.776142 6.77614 1 6.5 1H1.70711L8.85355 8.14645C9.04882 8.34171 9.04882 8.65829 8.85355 8.85355C8.65829 9.04882 8.34171 9.04882 8.14645 8.85355L1 1.70711V6.5C1 6.77614 0.776142 7 0.5 7C0.223858 7 0 6.77614 0 6.5V0.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 0.5C10 0.223858 10.2239 0 10.5 0H16.7C17.418 0 18 0.582029 18 1.3V16.7C18 17.418 17.418 18 16.7 18H1.3C0.582029 18 0 17.418 0 16.7V10.5C0 10.2239 0.223858 10 0.5 10C0.776142 10 1 10.2239 1 10.5V16.7C1 16.8657 1.13431 17 1.3 17H16.7C16.8657 17 17 16.8657 17 16.7V1.3C17 1.13432 16.8657 1 16.7 1H10.5C10.2239 1 10 0.776142 10 0.5Z'
    />
  </svg>
);

export default PictureInPictureLeaveIcon;
